import {gql} from 'apollo-angular'


export var update_project_dd_checklist_group = gql`
    mutation updateProjectDdChecklistGroup($id: ID!, $timing_issues: String, $screening_delay: Int, $high_priority: Boolean, $active: Boolean){
      updateProjectDdChecklistGroup(id: $id, timing_issues: $timing_issues, screening_delay: $screening_delay, high_priority: $high_priority, active: $active){
        id
        timing_issues
        high_priority
        screening_delay
      }
    }
  `


export var update_project_dd_checklist_selection = gql`
    mutation updateProjectDdChecklistSelection($id: ID!, $dd_checklist_state_id: ID){
      updateProjectDdChecklistSelection(id: $id, dd_checklist_state_id: $dd_checklist_state_id){
        id
        ddChecklistState {
          id
          name
        }
        ddChecklistItem {
          id
          name
          active
          ddChecklist {
            id
            name
          }
        }
        projectDdChecklistDates {
          ddChecklistState {
            name
            id
          }
          date
          id
        }
        projectDdChecklistDetailDates {
          date
          id
          ddChecklistDate {
            id
            name
          }
        }
      }
    }
`

export var add_project_dd_checklist_date = gql`
    mutation addProjectDdChecklistDate(
      $dd_checklist_state_id: ID!,
      $project_dd_checklist_selection_id: ID!,
      $date: String!
    ){
      addProjectDdChecklistDate(
        dd_checklist_state_id: $dd_checklist_state_id,
        project_dd_checklist_selection_id: $project_dd_checklist_selection_id
        date: $date
      ){
        ddChecklistState {
          name
          id
        }
        date
        id
      }
    }
`

export var update_project_dd_checklist_date = gql`
    mutation updateProjectDdChecklistDate($id: ID!, $date: String){
      updateProjectDdChecklistDate(id: $id, date: $date){
        ddChecklistState {
          name
          id
        }
        date
        id
      }
    }
`

export var delete_project_dd_checklist_date = gql`
    mutation deleteProjectDdChecklistDate($id: ID!){
      deleteProjectDdChecklistDate(id: $id){
        id
      }
    }
`

export var add_project_dd_checklist_selection = gql`
    mutation addProjectDdChecklistSelection(
      $project_dd_checklist_group_id: ID!,
      $dd_checklist_item_id: ID!,
      $dd_checklist_state_id: ID!
    ){
      addProjectDdChecklistSelection(
        project_dd_checklist_group_id: $project_dd_checklist_group_id,
        dd_checklist_item_id: $dd_checklist_item_id,
        dd_checklist_state_id: $dd_checklist_state_id
      ){
        id
      }
    }
`

export var add_project_dd_checklist_detail_date = gql`
    mutation addProjectDdChecklistDetailDate(
      $project_dd_checklist_selection_id: ID!
      $dd_checklist_date_id: ID!
      $date: String!
    ){
      addProjectDdChecklistDetailDate(
        project_dd_checklist_selection_id: $project_dd_checklist_selection_id,
        dd_checklist_date_id: $dd_checklist_date_id,
        date: $date
      ){
        id
      }
    }
`

export var update_project_dd_checklist_detail_date = gql`
    mutation updateProjectDdChecklistDetailDate(
      $id: ID!,
      $date: String!
    ){
      updateProjectDdChecklistDetailDate(
        id:$id,
        date: $date
      ){
        id
      }
    }
`
